export default __webpack_public_path__ + "static/ah-d40c47826f0eeee8af01736d47ceff25.svg";